// extracted by mini-css-extract-plugin
export default {"app_root":"App_app_root__VZTJn","main_area":"App_main_area__pX1B+"};